<div class="loadingScreen" *ngIf="loadingScreen">
    <div class="fake-loader-box">
        <img src="../assets/images/loadingsports.gif" alt="Loading" class="loader-gif" />

        <div class="progress-bar-wrap">
            <div class="progress-bar-fill" [style.width.%]="progress"></div>
        </div>
    </div>
</div>
<router-outlet *ngIf="!loadingScreen"></router-outlet>
<app-snackbar></app-snackbar>